import React from 'react'
import { Modal } from 'lib/modal'
import { AlertTriangle } from 'react-feather'
import { Spinner } from './Spinner'

const theme = {
  modal: 'flex self-start items-center justify-center p-8 w-full min-h-screen bg-blue-100',
  cancelButton: 'w-full btn text-black btn-white py-2 rounded-full',
  confirmButton: 'w-full btn btn-blue py-2 rounded-full',
  isFullScreen: true
}

export default function ConfirmationModal(props) {
  const {
    isOpen = true,
    onCancel = () => { },
    closeModal = onCancel,
    isLoading,
    onConfirm,
    title = 'Confirmation',
    message = 'Please confirm you want to take this action',
    confirmButtonText = 'Take me back to the form',
    cancelButtonText = 'Yes, exit'
  } = props

  const styles = { ...theme, ...props.classNames }

  return (
    <Modal
      isOpen={isOpen}
      className={styles.modal}
      style={styles.isFullScreen ? { minHeight: '100dvh', maxHeight: '100dvh' } : {}}
      closeModal={closeModal}
    >
      <div className="h-full">
        <div className={[
          'w-full flex items-center justify-center',
          'bg-white-200 mx-auto mb-3'
        ]}>
        </div>
        <div className="leading-snug text-center mb-6">
          <h3 className="font-platform text-black text-2xl">
            {title}
          </h3>
          <p className="text-gray-700 mt-2 font-light leading-snug">
            {message}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div className='row'>
            <button
              children={cancelButtonText}
              className={styles.cancelButton}
              onClick={onCancel}
            />
          </div>
          <div className='row'>
            <button
              className={styles.confirmButton}
              onClick={onConfirm}
              children={isLoading ? <Spinner color="white" className='text-xs mx-auto' /> : confirmButtonText}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}
